// @ts-nocheck

import { ReviewActionTypes } from '../types/actions/review';

type ReviewCheck = {
  type: typeof ReviewActionTypes.CHECK;
};

export const reviewCheck = (): ReviewCheck => ({
  type: ReviewActionTypes.CHECK,
});

type ReviewRate = {
  type: typeof ReviewActionTypes.RATE;
};

export const reviewRate = (): ReviewRate => ({
  type: ReviewActionTypes.RATE,
});

type ReviewDisable = {
  type: typeof ReviewActionTypes.DISABLE;
};

export const reviewDisable = (): ReviewDisable => ({
  type: ReviewActionTypes.DISABLE,
});

type ReviewOpenDialog = {
  type: typeof ReviewActionTypes.OPEN_DIALOG;
};

export const reviewOpenDialog = (): ReviewOpenDialog => ({
  type: ReviewActionTypes.OPEN_DIALOG,
});

type ReviewCloseDialog = {
  type: typeof ReviewActionTypes.CLOSE_DIALOG;
};

export const reviewCloseDialog = (): ReviewCloseDialog => ({
  type: ReviewActionTypes.CLOSE_DIALOG,
});

export type Action = ReviewCheck | ReviewRate | ReviewDisable | ReviewOpenDialog | ReviewCloseDialog;
